import React, { useState, useEffect } from 'react';

/**
 * ScrollProgressBar
 * Displays a sleek scroll progress bar along the bottom edge of the navbar.
 * Uses Seikural orange branding colors (#f97316 / #ea580c).
 * Layout and positioning handled by Bootstrap 5.
 */
const ScrollProgressBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (totalScroll > 0) {
        const currentProgress = (window.scrollY / totalScroll) * 100;
        setScrollProgress(Math.min(100, Math.max(0, currentProgress)));
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    // Initial check on load
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className="position-absolute bottom-0 start-0 w-100"
      style={{
        height: '3px',
        backgroundColor: 'transparent',
        pointerEvents: 'none',
        zIndex: 10,
      }}
      aria-hidden="true"
    >
      <div
        className="h-100"
        style={{
          width: `${scrollProgress}%`,
          background: 'linear-gradient(90deg, #ea580c, #f97316, #fb923c)',
          transition: 'width 0.12s ease-out',
        }}
      />
    </div>
  );
};

export default ScrollProgressBar;
